export default "__VITE_ASSET__5efee9eb__"